module.exports = __webpack_public_path__ + "media/bundles/OrderRecap/GameCard/assets/banner-gamindo-9abaf9061c8c2a5040d454d1fa25df59.png";